import { Card, Dialog } from '@mui/material';
import { ReactElement, useState } from 'react';
import {
  Datagrid,
  FunctionField,
  Filter,
  List,
  DateInput,
  TextField,
  useTranslate,
  NumberField,
} from 'react-admin';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import JsonDetailViewer from '../../../components/JsonDetailViewer';
// 导入数据提供者初始化
import './init';
import FilterGroup from 'src/pages/admin/components/FilterGroup';

const ListFilter = (props: any & { translate: any }) => (
  <Filter {...props}>
    <FilterGroup alwaysOn spacing={0} p={1} pt={2}>
      <DateInput source="startDate" label={props.translate('activity.common.fromTime')} />
    </FilterGroup>
    <FilterGroup alwaysOn spacing={0} p={1} pt={2}>
      <DateInput source="endDate" label={props.translate('activity.common.toTime')} />
    </FilterGroup>
  </Filter>
);

const View = () => {
  const translate = useTranslate();
  const [popup, setPopup] = useState<ReactElement>();
  return (
    <PermissionGuard resource="activity-task-completion" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.activityTaskCompletionStats')}
          links={[
            { name: translate('resource.activity') },
            { name: translate('resource.activityTaskCompletionStats') },
          ]}
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            resource="activityTaskCompletionStats"
            actions={false}
            empty={false}
            exporter={false}
            filters={<ListFilter translate={translate} />}
            filterDefaultValues={{
              startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
              endDate: new Date(Date.now()),
            }}
          >
            <Datagrid rowClick={false}>
              <TextField source="id" label={translate('activity.common.id')} sortable={false} />
              <TextField source="taskName" label={translate('activity.taskCompletionStats.taskName')} sortable={false} />
              <NumberField source="completionCount" label={translate('activity.taskCompletionStats.completionCount')} sortable={false} />
              <FunctionField
                label={translate('activity.common.detail')}
                render={(record: any) => (
                  <JsonDetailViewer data={record} maxLength={20} label={translate('activity.common.detail')} />
                )}
                sortable={false}
              />
            </Datagrid>
          </List>
        </Card>

        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
